module.exports = __webpack_public_path__ + "img/coffin_jurassic.fx.0191e54.png";